import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types';

import {updateData} from '../../../routers/data'
import InputText from '../../components/inputText'
import InputSelect from '../../components/inputSelect'
import {FielsFilter} from '../functions'
import { retrieveTemporalDetails } from '../../../lib/ApiServices'


class contactInformation extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  componentWillMount(){
    const userKey = localStorage.getItem('userKey')
    if(userKey){
      const a = Promise.resolve(retrieveTemporalDetails(userKey))
      a.then(res => {
        if (res.secondSurname === "underfined") {
          res.secondSurname = '';
        }
        res.secondSurname = res.secondSurname || '';
        return this.props.updateData({ contact: res });
      })
    }
  }

  generateUserKey = () => {
    return '_' + Math.random().toString(36).substr(2, 9);
  }

  onChange = (name, value, title, id) =>{
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].dataresume
  
    const {isPassager1} = this.props.data.values
    const filter = ['name', 'surname', 'secondSurname', 'typeDocument', 'numberDocument']
    const contact = this.props.data['contact']
    const adult1 = this.props.data['adult1']
    if(value === undefined || value === 'undefined'){
      value = ' '
    }
    const result = FielsFilter(langPlace, name, value, contact)
  
    //Save field error
    if (result.isError){
      this.props.updateData({errors: {...this.props.data.errors, [id]: result}})
    } else if (this.props.data.errors[id] !== undefined) {
      delete this.props.data.errors[id]
      this.props.updateData({errors: {...this.props.data.errors}})
    }
  
    if (isPassager1 & (filter.indexOf(name) >=0)){
      this.props.updateData({contact: {...contact, [name]: value}, adult1: {...adult1, [name]: value}})
    } else {
      this.props.updateData({contact: {...contact, [name]: value}})
    }
  } 

  render() {
    let userKey = localStorage.getItem('userKey')
    if(!userKey){
      userKey = this.generateUserKey()
      localStorage.setItem('userKey', userKey)
      this.props.updateData({contact: {...this.props.data.contact, userKey}})
    }
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].dataresume.names
    const {prefixes} = languages[langUrl]

    const errors = this.props.errors
    const values = this.props.data['contact']

    return (
      <div className='container contact-information'>
        <div className='col-lg-12 col-md-12 col-sm-12'>
          <div className='row'>
            <div className='col-lg-4 col-md-4 col-sm-6 col-xs-6 no-padding'>
              <InputText name='name' title={langPlace.name} value={values} errors={errors} section='contact' onChange={this.onChange}/>
            </div>
            <div className='col-lg-4 col-md-4 col-sm-6 col-xs-6 no-padding'>
              <InputText name='surname' title={langPlace.surname} value={values} errors={errors} section='contact' onChange={this.onChange}/>
            </div>
            <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12 no-padding'>
              <InputText name='secondSurname' title={langPlace.secondSurname} value={values} errors={errors} section='contact' onChange={this.onChange}/>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-4 col-md-4 col-sm-12 col-xs-12 no-padding'>
              <InputText name='numberDocument' title={langPlace.numberDocument} value={values} errors={errors} section='contact' onChange={this.onChange}/>
            </div>
            <div className='col-lg-4 col-md-4 col-sm-3 col-xs-6 no-padding'>
              <InputSelect name='prefix' title={langPlace.prefix} value={values} array={prefixes} errors={errors} section='contact' onChange={this.onChange}/>
            </div>
            <div className='col-lg-4 col-md-4 col-sm-6 col-xs-6 no-padding'>
              <InputText name='phone' title={langPlace.phone} value={values} errors={errors} section='contact' onChange={this.onChange}/>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-5 col-md-5 col-sm-6 col-xs-6 no-padding'>
              <InputText name='email' title={langPlace.email} value={values} errors={errors} section='contact' onChange={this.onChange}/>
            </div>
            <div className='col-lg-5 col-md-5 col-sm-6 col-xs-6 no-padding'>
              <InputText name='repeatEmail' title={langPlace.repeatEmail} value={values} errors={errors} section='contact' onChange={this.onChange}/>
            </div>
            <div className='col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding'>
              <InputText name='postalcode' title={langPlace.postalcode} value={values} errors={errors} section='contact' onChange={this.onChange}/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({settings: state.settings, data: state.data, errors: state.data.errors}),
  {updateData}
)(contactInformation)



// WEBPACK FOOTER //
// ./src/shared/routes/routeData/components/formBooking.js